import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-609dfe5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "content new-gem-text" }, "New gem!", -1))
const _hoisted_2 = { class: "address-text" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "content new-gem-text" }, "New gem!", -1))
const _hoisted_4 = { class: "address-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createBlock(_component_van_row, {
    justify: _ctx.justify,
    class: "fill-width gem-message-closed"
  }, {
    default: _withCtx(() => [
      (_ctx.isSentBySelf)
        ? (_openBlock(), _createBlock(_component_van_cell, {
            key: 0,
            class: "gem-message",
            style: _normalizeStyle(_ctx.gemMessageStyle),
            center: ""
          }, {
            "right-icon": _withCtx(() => [
              _createVNode(_component_van_icon, {
                class: "gem-icon",
                name: _ctx.getGemImageUrl,
                onClick: _ctx.goToDropGem
              }, null, 8, ["name", "onClick"])
            ]),
            title: _withCtx(() => [
              _createVNode(_component_van_col, { class: "text" }, {
                default: _withCtx(() => [
                  _hoisted_1,
                  _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.gemLocation), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["style"]))
        : (_openBlock(), _createBlock(_component_van_cell, {
            key: 1,
            class: "gem-message",
            style: _normalizeStyle(_ctx.gemMessageStyle),
            center: ""
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_van_icon, {
                class: "gem-icon",
                name: _ctx.getGemImageUrl,
                onClick: _ctx.goToDropGem
              }, null, 8, ["name", "onClick"])
            ]),
            title: _withCtx(() => [
              _createVNode(_component_van_col, { class: "text" }, {
                default: _withCtx(() => [
                  _hoisted_3,
                  _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.gemLocation), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["style"]))
    ]),
    _: 1
  }, 8, ["justify"]))
}